export default __webpack_public_path__ + "static/media/Banner - Hybridshell - Black.c1f2230a.jpg";